// LIST
export const START_FETCHING_EDITIONS = 'START_FETCHING_EDITIONS';
export const GET_EDITIONS_SUCCESS = 'GET_EDITIONS_SUCCESS';
export const GET_EDITIONS_ERROR = 'GET_EDITIONS_ERROR';

// WRITE - one pipeline for the edit, which polls a job after the request
export const START_SAVING_EDITION = 'START_SAVING_EDITION';
export const SAVE_EDITION_SUCCESS = 'SAVE_EDITION_SUCCESS';
export const SAVE_EDITION_ERROR = 'SAVE_EDITION_ERROR';
// Not an error: the page unmounted mid-write and its abort fired. The `saving` flag still has to be
// released, because the slice outlives the route and a flag left raised disables the row actions
// on the next visit
export const SAVE_EDITION_ABORTED = 'SAVE_EDITION_ABORTED';

// MODALS - view and edit are mutually exclusive: opening one closes the other
export const SHOW_EDITION_VIEW_MODAL = 'SHOW_EDITION_VIEW_MODAL';
export const HIDE_EDITION_VIEW_MODAL = 'HIDE_EDITION_VIEW_MODAL';
export const SHOW_EDITION_EDIT_MODAL = 'SHOW_EDITION_EDIT_MODAL';
export const HIDE_EDITION_EDIT_MODAL = 'HIDE_EDITION_EDIT_MODAL';

// The license edit form, opened on top of an edition's dialog without leaving the page. The
// edition dialog is hidden, not closed, while it is up, so a half-edited edition is kept
export const SHOW_LICENSE_EDIT_MODAL = 'SHOW_LICENSE_EDIT_MODAL';
export const HIDE_LICENSE_EDIT_MODAL = 'HIDE_LICENSE_EDIT_MODAL';
